(function () {
    var $body = $('body');

    var shareAccess = {
        $target: null,
        $toggle: null,
        $shareAccessPopUp: null,

        init: function () {
            shareAccess.$toggle = $('.share-access__ctrl');
            shareAccess.$target = $('.share-access');
            shareAccess.$shareAccessPopUp = $('.share-access__modal');

            shareAccess.control();
        },

        control: function () {
            shareAccess.$toggle.on('click', function () {
                if (!$(this).hasClass('clicked')) {
                    shareAccess.render();
                }

                $(this).addClass('clicked');
            });

            $('#terms-and-conditions').on('change', function () {
                var $this = $(this),
                    AjaxLink = $this.data('ajax-link');

                if ($this.data('shareable-link') === '') {
                    shareAccess.$shareAccessPopUp.find('.shareable__error').addClass('hidden').text('');
                    shareAccess.$shareAccessPopUp.find('.shareable__text').addClass('js--loading');
                    $this.attr('disabled', true);
                    $.ajax({
                        method: 'Post',
                        url: AjaxLink,
                        success: function (data) {
                            shareAccess.$shareAccessPopUp.find('.shareable__text').removeClass('js--loading');
                            $this.removeAttr('disabled');
                            if (typeof data === 'object' && data.status.length) {
                                if (data.status === 'authorized') {
                                    shareAccess.acceptTerms(true);
                                    shareAccess.$shareAccessPopUp.find('#shareable__text').html(data.shareUrl);
                                    $this.data('shareable-link', data.shareUrl);
                                } else if (data.status === 'unauthorized') {
                                    shareAccess.$shareAccessPopUp
                                        .find('.shareable__error')
                                        .removeClass('hidden')
                                        .text(data.err);
                                }
                            }
                        },
                        error: function (xhr) {
                            if (xhr.status === 404) {
                                $this.removeAttr('disabled');
                                $this.prop('checked', false);
                                if (xhr && xhr.responseJSON) {
                                    shareAccess.$shareAccessPopUp.find('.shareable__text').removeClass('js--loading');
                                    shareAccess.$shareAccessPopUp
                                        .find('.shareable__error')
                                        .removeClass('hidden')
                                        .text(xhr.responseJSON.msg);
                                }
                            }
                        },
                    });
                } else {
                    if ($this.prop('checked')) {
                        shareAccess.acceptTerms(true);
                        shareAccess.$shareAccessPopUp.find('#shareable__text').html($this.data('shareable-link'));
                    } else {
                        shareAccess.acceptTerms(false);
                    }
                }
            });

            const termsConditionsLabel = document.querySelector('label[for="terms-and-conditions"]');
            termsConditionsLabel?.addEventListener('keydown', element => {
                element.code === 'Enter' && element.target.click();
            });

            $body.on('click', '.shareable__btn', function (e) {
                e.preventDefault();
                shareAccess.copyLink();
            });
        },

        render: function () {
            $.ajax({
                method: 'GET',
                url: shareAccess.$target.data('share-access'),
                success: function (data) {
                    if (typeof data === 'object' && data.authorized) {
                        shareAccess.$target.removeClass('hidden');
                        shareAccess.$shareAccessPopUp.appendTo('body');
                    } else {
                        shareAccess.failed();
                    }
                },
                fail: function () {
                    shareAccess.failed();
                },
            });
        },

        acceptTerms: function (checker) {
            switch (checker) {
                case true:
                    shareAccess.$shareAccessPopUp.find('.shareable__field').css('visibility', 'visible');
                    shareAccess.$shareAccessPopUp.find('.shareable__btn').attr('disabled', false);
                    break;
                case false:
                    shareAccess.$shareAccessPopUp.find('.shareable__field').css('visibility', 'hidden');
                    shareAccess.$shareAccessPopUp.find('.shareable__btn').attr('disabled', true);
                    break;
            }
        },
        failed: function () {
            shareAccess.$target.remove();
            shareAccess.$shareAccessPopUp.remove();
        },
        copyLink: function () {
            let shareableLink = document.querySelector('#shareable__text'),
                extraTextArea = document.querySelector('.shareable__text-area');

            extraTextArea.innerHTML = shareableLink.textContent;

            const textToCopy = shareableLink?.textContent || shareableLink?.innerText;

            navigator.clipboard
                .writeText(textToCopy)
                .then(() => {
                    const shareableBtn = document.querySelector('.shareable__btn');
                    shareableBtn?.focus();
                    UX.utils.screenReaderSpeak('Link copied to clipboard');
                    shareableBtn?.blur();
                })
                .catch();
        },
    };

    UX.shareAccess = shareAccess; // add to global namespace
})();
